import Styles from './OverviewStyles.module.scss';

const OverviewContainer = ({ children }) => <div className={Styles.container}>{children}</div>;

OverviewContainer.propTypes = {};

export default OverviewContainer;
